<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts">
	let i = 0;
	export default {
		inheritAttrs: false,
	};
</script>
<script setup lang="ts">
	const id = `checkbox${i++}`;
	defineProps<{
		label: string;
	}>();
	const modelValue = defineModel<boolean>();
</script>

<template>
	<label
		:for="id"
		class="checkbox relative flex cursor-pointer select-none pb-4 gap-2"
		:class="$attrs.class"
	>
		<span class="slider w-10 h-6 rounded-xl bg-separator relative" />
		<span class="body-2-bold text-jca-dark-blue">{{ label }}</span>
		<input
			:id="id"
			v-model="modelValue"
			type="checkbox"
			class="w-0 h-0 opacity-0"
		/>
	</label>
</template>

<style scoped>
	.slider:before {
		position: absolute;
		content: "";
		width: 1rem;
		height: 1rem;
		right: 1.25rem;
		top: 0.25rem;
		border-radius: 0.5rem;
		background-color: var(--theme-text-light);
		transition: 0.2s;
	}

	.checkbox:has(input:is(:focus, :hover)) .slider {
		background-color: var(--theme-surface-hover);
	}

	.checkbox:has(input:checked) .slider {
		background-color: var(--theme-jca-dark-blue);
	}

	.checkbox:has(input:checked) .slider:before {
		transform: translateX(1rem);
	}
</style>
